import React , { Component } from 'react';
import styled, { css, keyframes } from 'react-emotion';
import { screenWidths } from './../../utils/constants';

const Info = styled.div`
    width: 100%;

    .email {
        font-family: ZeitungMicroPro-Light;
        font-size: 20px;
      }
    
    .number {
        font-family: ZeitungMicroPro-Light;
        font-size: 20px;
    }
    
    .address {
        font-family: ZeitungMicroPro-Light;
        font-size: 14px;
    }
    
`;

export const Title = styled.h2`
  font-family: ZeitungMicroPro-Light;
  font-weight: normal;
  margin-bottom: 55px;
  font-size: 50px;
  color:  #424149;
  @media screen and (min-width: ${screenWidths.lg}px) {
    text-align: left;
  }
`;

export default class Visitanos extends Component {
    render() {
        return (
                <Info>
                     <Title>{this.props.title}</Title>

                     <iframe
                        src="https://snazzymaps.com/embed/130783"   
                        width="100%"
                        height="357"
                        frameBorder="0"
                        style={{ border: 0 }}
                        allowFullScreen
                        />

                    <p className="address">{this.props.address}</p>
                    <p className="email">{this.props.email}</p>
                    <p className="number">{this.props.number}</p>

                </Info>          
        )
    }    
}


// WEBPACK FOOTER //
// ./src/components/About/Visitanos.js